import {connect} from '@store/@common';

import {assignmentsByKpiId, kpiTargetTreeSorted, selectedGoal, selectedKpis} from '@store/kpi';
import KpiGoalActions from '@store/kpi/KpiTargetActions';
import UserActions from 'actions/UserActions';
import {users} from '@store/user';

import {KpiGoalsList} from './KpiGoalsList';

const mapStateToProps = {
  kpiTargetTrees: kpiTargetTreeSorted,
  selectedGoal,
  selectedKpis,
  users,
  assignmentsByKpiId,
};

const mapDispatchToProps = {
  fetchGoalKpiTree: KpiGoalActions.fetchGoalKpiTree,
  fetchUsers: UserActions.fetchAll,
};

export default connect(KpiGoalsList, mapStateToProps, mapDispatchToProps);
